import { render } from "./PaymentSlip.vue?vue&type=template&id=085e914e"
import script from "./PaymentSlip.vue?vue&type=script&lang=js"
export * from "./PaymentSlip.vue?vue&type=script&lang=js"

import "./PaymentSlip.vue?vue&type=style&index=0&id=085e914e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__